import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-order-management',
  templateUrl: './service-order-management.component.html',
  styleUrls: ['./service-order-management.component.scss']
})
export class ServiceOrderManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
